import React, { useState } from "react";
import { Card, CardBody, CardTitle, Col, Container, Row, Input, Label, Button, Table, CardHeader } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BalanceFeeStatement = () => {
    // State for selected class and division
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("");

    // Dummy data for classes and divisions
    const classes = [
        { id: 1, name: "Class 1" },
        { id: 2, name: "Class 2" },
        { id: 3, name: "Class 3" },
    ];

    const divisions = [
        { id: 1, name: "Division A", classId: 1 },
        { id: 2, name: "Division B", classId: 1 },
        { id: 3, name: "Division A", classId: 2 },
        { id: 4, name: "Division B", classId: 2 },
        { id: 5, name: "Division A", classId: 3 },
        { id: 6, name: "Division B", classId: 3 },
    ];

    // Dummy data for students and their fee statements
    const students = [
        // Class 1 - Division A
        {
            id: 1,
            admissionNumber: "12345",
            name: "John Doe",
            fatherName: "Mr. Doe",
            class: "Class 1",
            division: "Division A",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF001",
                    dueDate: "2023-10-15",
                    status: "Paid",
                    amount: 5000,
                    discount: 500,
                    fine: 0,
                    paid: 4500,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feesGroup: "Library Fee",
                    feeCode: "LF001",
                    dueDate: "2023-10-20",
                    status: "Unpaid",
                    amount: 1000,
                    discount: 0,
                    fine: 50,
                    paid: 0,
                    balance: 1050,
                },
            ],
        },
        {
            id: 2,
            admissionNumber: "67890",
            name: "Jane Smith",
            fatherName: "Mr. Smith",
            class: "Class 1",
            division: "Division A",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF001",
                    dueDate: "2023-10-15",
                    status: "Partial",
                    amount: 5000,
                    discount: 0,
                    fine: 100,
                    paid: 3000,
                    balance: 2100,
                },
            ],
        },

        // Class 1 - Division B
        {
            id: 3,
            admissionNumber: "54321",
            name: "Alice Johnson",
            fatherName: "Mr. Johnson",
            class: "Class 1",
            division: "Division B",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF001",
                    dueDate: "2023-10-15",
                    status: "Paid",
                    amount: 5000,
                    discount: 0,
                    fine: 0,
                    paid: 5000,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feesGroup: "Sports Fee",
                    feeCode: "SF001",
                    dueDate: "2023-10-25",
                    status: "Unpaid",
                    amount: 800,
                    discount: 0,
                    fine: 20,
                    paid: 0,
                    balance: 820,
                },
            ],
        },
        {
            id: 4,
            admissionNumber: "98765",
            name: "Bob Brown",
            fatherName: "Mr. Brown",
            class: "Class 1",
            division: "Division B",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF001",
                    dueDate: "2023-10-15",
                    status: "Partial",
                    amount: 5000,
                    discount: 1000,
                    fine: 50,
                    paid: 3000,
                    balance: 2050,
                },
            ],
        },

        // Class 2 - Division A
        {
            id: 5,
            admissionNumber: "11223",
            name: "Charlie Davis",
            fatherName: "Mr. Davis",
            class: "Class 2",
            division: "Division A",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF002",
                    dueDate: "2023-10-15",
                    status: "Paid",
                    amount: 6000,
                    discount: 0,
                    fine: 0,
                    paid: 6000,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feesGroup: "Library Fee",
                    feeCode: "LF002",
                    dueDate: "2023-10-20",
                    status: "Unpaid",
                    amount: 1200,
                    discount: 0,
                    fine: 60,
                    paid: 0,
                    balance: 1260,
                },
            ],
        },
        {
            id: 6,
            admissionNumber: "33445",
            name: "Eva Green",
            fatherName: "Mr. Green",
            class: "Class 2",
            division: "Division A",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF002",
                    dueDate: "2023-10-15",
                    status: "Partial",
                    amount: 6000,
                    discount: 500,
                    fine: 100,
                    paid: 4000,
                    balance: 2500,
                },
            ],
        },

        // Class 2 - Division B
        {
            id: 7,
            admissionNumber: "55667",
            name: "Frank White",
            fatherName: "Mr. White",
            class: "Class 2",
            division: "Division B",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF002",
                    dueDate: "2023-10-15",
                    status: "Paid",
                    amount: 6000,
                    discount: 0,
                    fine: 0,
                    paid: 6000,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feesGroup: "Sports Fee",
                    feeCode: "SF002",
                    dueDate: "2023-10-25",
                    status: "Unpaid",
                    amount: 1000,
                    discount: 0,
                    fine: 30,
                    paid: 0,
                    balance: 1030,
                },
            ],
        },
        {
            id: 8,
            admissionNumber: "77889",
            name: "Grace Hall",
            fatherName: "Mr. Hall",
            class: "Class 2",
            division: "Division B",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF002",
                    dueDate: "2023-10-15",
                    status: "Partial",
                    amount: 6000,
                    discount: 1000,
                    fine: 50,
                    paid: 4000,
                    balance: 2050,
                },
            ],
        },

        // Class 3 - Division A
        {
            id: 9,
            admissionNumber: "55667",
            name: "Frank White",
            fatherName: "Mr. White",
            class: "Class 3",
            division: "Division A",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF002",
                    dueDate: "2023-10-15",
                    status: "Paid",
                    amount: 6000,
                    discount: 0,
                    fine: 0,
                    paid: 6000,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feesGroup: "Sports Fee",
                    feeCode: "SF002",
                    dueDate: "2023-10-25",
                    status: "Unpaid",
                    amount: 1000,
                    discount: 0,
                    fine: 30,
                    paid: 0,
                    balance: 1030,
                },
            ],
        },
        {
            id: 10,
            admissionNumber: "77889",
            name: "Grace Hall",
            fatherName: "Mr. Hall",
            class: "Class 3",
            division: "Division A",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF002",
                    dueDate: "2023-10-15",
                    status: "Partial",
                    amount: 6000,
                    discount: 1000,
                    fine: 50,
                    paid: 4000,
                    balance: 2050,
                },
            ],
        },

        // Class 3 - Division B
        {
            id: 1,
            admissionNumber: "12345",
            name: "John Doe",
            fatherName: "Mr. Doe",
            class: "Class 3",
            division: "Division B",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF001",
                    dueDate: "2023-10-15",
                    status: "Paid",
                    amount: 5000,
                    discount: 500,
                    fine: 0,
                    paid: 4500,
                    balance: 0,
                },
                {
                    siNo: 2,
                    feesGroup: "Library Fee",
                    feeCode: "LF001",
                    dueDate: "2023-10-20",
                    status: "Unpaid",
                    amount: 1000,
                    discount: 0,
                    fine: 50,
                    paid: 0,
                    balance: 1050,
                },
            ],
        },
        {
            id: 2,
            admissionNumber: "67890",
            name: "Jane Smith",
            fatherName: "Mr. Smith",
            class: "Class 3",
            division: "Division B",
            fees: [
                {
                    siNo: 1,
                    feesGroup: "Tuition Fee",
                    feeCode: "TF001",
                    dueDate: "2023-10-15",
                    status: "Partial",
                    amount: 5000,
                    discount: 0,
                    fine: 100,
                    paid: 3000,
                    balance: 2100,
                },
            ],
        },
    ];

    // State to store filtered students
    const [filteredStudents, setFilteredStudents] = useState([]);

    // Handle form submission
    const handleSubmit = () => {
        // Filter students based on selected class and division
        const filtered = students.filter(
            (student) => student.class === selectedClass && student.division === selectedDivision
        );
        setFilteredStudents(filtered);
    };

    // Calculate grand totals for a student's fees
    const calculateGrandTotals = (fees) => {
        return fees.reduce(
            (totals, fee) => {
                totals.amount += fee.amount;
                totals.discount += fee.discount;
                totals.fine += fee.fine;
                totals.paid += fee.paid;
                totals.balance += fee.balance;
                return totals;
            },
            { amount: 0, discount: 0, fine: 0, paid: 0, balance: 0 }
        );
    };

    // Breadcrumb items
    const breadcrumbItems = [
        { title: "Reports", link: "/" },
        { title: "Finance Reports", link: "/" },
        { title: "Balance Fee Statement", link: "/admin/balance-fee-statement" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Balance Fee Statement" breadcrumbItems={breadcrumbItems} />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center flex-wrap">
                                    <h4 className="card-title mb-0 flex-grow-1">Balance Fee Statement</h4>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        {/* Class Select Input */}
                                        <Col lg={4}>
                                            <Label>Class</Label>
                                            <Input
                                                type="select"
                                                value={selectedClass}
                                                onChange={(e) => setSelectedClass(e.target.value)}
                                            >
                                                <option value="">Select Class</option>
                                                {classes.map((cls) => (
                                                    <option key={cls.id} value={cls.name}>
                                                        {cls.name}
                                                    </option>
                                                ))}
                                            </Input>
                                        </Col>

                                        {/* Division Select Input */}
                                        <Col lg={4}>
                                            <Label>Division</Label>
                                            <Input
                                                type="select"
                                                value={selectedDivision}
                                                onChange={(e) => setSelectedDivision(e.target.value)}
                                            >
                                                <option value="">Select Division</option>
                                                {divisions
                                                    .filter((div) => div.classId === classes.find((cls) => cls.name === selectedClass)?.id)
                                                    .map((div) => (
                                                        <option key={div.id} value={div.name}>
                                                            {div.name}
                                                        </option>
                                                    ))}
                                            </Input>
                                        </Col>

                                        {/* Submit Button */}
                                        <Col lg={4} className="d-flex align-items-end">
                                            <Button color="primary" onClick={handleSubmit}>
                                                Submit
                                            </Button>
                                        </Col>
                                    </Row>

                                    {/* Display Student Cards */}
                                    {filteredStudents.map((student) => {
                                        const grandTotals = calculateGrandTotals(student.fees);
                                        return (
                                            <Card key={student.id} className="mt-4">
                                                <CardBody>
                                                    <CardTitle className="h5">
                                                        {student.name} - {student.admissionNumber}
                                                    </CardTitle>
                                                    <p>
                                                        Father: {student.fatherName} | Class: {student.class} | Division:{" "}
                                                        {student.division}
                                                    </p>

                                                    {/* Fee Table */}
                                                    <Table striped>
                                                        <thead>
                                                            <tr>
                                                                <th>SI No</th>
                                                                <th>Fees Group</th>
                                                                <th>Fee Code</th>
                                                                <th>Due Date</th>
                                                                <th>Status</th>
                                                                <th>Amount</th>
                                                                <th>Discount</th>
                                                                <th>Fine</th>
                                                                <th>Paid</th>
                                                                <th>Balance</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {student.fees.map((fee) => (
                                                                <tr key={fee.siNo}>
                                                                    <td>{fee.siNo}</td>
                                                                    <td>{fee.feesGroup}</td>
                                                                    <td>{fee.feeCode}</td>
                                                                    <td>{fee.dueDate}</td>
                                                                    <td>{fee.status}</td>
                                                                    <td>{fee.amount}</td>
                                                                    <td>{fee.discount}</td>
                                                                    <td>{fee.fine}</td>
                                                                    <td>{fee.paid}</td>
                                                                    <td>{fee.balance}</td>
                                                                </tr>
                                                            ))}
                                                            {/* Grand Totals Row */}
                                                            <tr style={{ fontWeight: "bold" }}>
                                                                <td colSpan="5">Grand Totals</td>
                                                                <td>{grandTotals.amount}</td>
                                                                <td>{grandTotals.discount}</td>
                                                                <td>{grandTotals.fine}</td>
                                                                <td>{grandTotals.paid}</td>
                                                                <td>{grandTotals.balance}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </CardBody>
                                            </Card>
                                        );
                                    })}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default BalanceFeeStatement;